// Généré par maquettes/outils/dc2react.py à partir de la maquette. Ne pas modifier à la main :
// changer maquettes/src puis relancer le script.
import React from 'react';

export default function Offres({ v }) {
  return (
    <section className="m-sec" id="offres" style={{ maxWidth: "1240px", margin: "0 auto", padding: "96px 24px", display: "flex", flexDirection: "column", gap: "28px" }}>
      <div style={{ display: "flex", flexWrap: "wrap", alignItems: "flex-end", justifyContent: "space-between", gap: "12px 48px" }}>
        <h2 style={{ margin: "0", fontSize: "clamp(32px, 3.4vw, 48px)", fontWeight: "800", fontStretch: "80%", lineHeight: "1.04" }}>
          Du sur-mesure, à prix fixe
        </h2>
        <p style={{ margin: "0", fontSize: "17px", color: "#4A5059" }}>
          Le prix dépend de ce que fait l'outil, pas du temps passé.
        </p>
      </div>
      <div style={{ padding: "28px", background: "#FFFFFF", border: `2px solid ${v.accent}`, borderRadius: "8px", boxShadow: "0 24px 48px -28px rgba(35, 71, 214, 0.45)", display: "flex", flexWrap: "wrap", gap: "24px 40px", alignItems: "stretch" }}>
        <div style={{ flex: "1 1 320px", minWidth: "0", display: "flex", flexDirection: "column", gap: "14px" }}>
          <p style={{ margin: "0", fontWeight: "800", fontSize: "24px", fontStretch: "85%" }}>
            Développement sur mesure
          </p>
          <p style={{ margin: "0", fontSize: "16px", color: "#30353C" }}>
            Construit sur vos données, à un prix fixé par écrit avant de commencer. On commence par un outil, puis on l'étend : vous ne payez que ce qui s'ajoute.
          </p>
          <p style={{ margin: "0", padding: "12px 14px", background: "#F1F4FF", color: "#1D2A66", borderRadius: "6px", fontSize: "14px" }}>
            <strong>
              Tarif de lancement :
            </strong>
            {" 2 030 € HT au lieu de 2 900 € pour un premier outil, si vous acceptez qu'il fasse l'objet d'une étude de cas."}
          </p>
        </div>
        <div style={{ flex: "1.4 1 440px", minWidth: "0", display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(min(200px, 100%), 1fr))", gap: "1px", background: "#E3E5E8", border: "1px solid #E3E5E8", alignSelf: "stretch" }}>
          <div style={{ padding: "18px", background: "#FBFBFA", display: "flex", flexDirection: "column", gap: "6px" }}>
            <span style={{ fontFamily: "'IBM Plex Mono', ui-monospace, monospace", fontSize: "12px", color: v.accent }}>
              Un outil
            </span>
            <span style={{ fontFamily: "'IBM Plex Mono', ui-monospace, monospace", fontSize: "26px", fontWeight: "600", whiteSpace: "nowrap" }}>
              <span style={{ fontSize: "14px", fontWeight: "400", color: "#4A5059" }}>
                dès
              </span>
              {" 2 900 € "}
              <span style={{ fontSize: "14px", fontWeight: "400", color: "#4A5059" }}>
                HT
              </span>
            </span>
            <span style={{ fontSize: "14px", color: "#30353C" }}>
              Un besoin réglé en 3 semaines, 30 jours de corrections.
            </span>
            <span style={{ fontSize: "13px", color: "#5A6068" }}>
              Exemple : le réappro de votre catalogue.
            </span>
          </div>
          <div style={{ padding: "18px", background: "#FBFBFA", display: "flex", flexDirection: "column", gap: "6px" }}>
            <span style={{ fontFamily: "'IBM Plex Mono', ui-monospace, monospace", fontSize: "12px", color: v.accent }}>
              Votre système
            </span>
            <span style={{ fontFamily: "'IBM Plex Mono', ui-monospace, monospace", fontSize: "26px", fontWeight: "600", whiteSpace: "nowrap" }}>
              <span style={{ fontSize: "14px", fontWeight: "400", color: "#4A5059" }}>
                dès
              </span>
              {" 7 500 € "}
              <span style={{ fontSize: "14px", fontWeight: "400", color: "#4A5059" }}>
                HT
              </span>
            </span>
            <span style={{ fontSize: "14px", color: "#30353C" }}>
              Plusieurs outils sur la même base, livrés par étapes, 60 jours de corrections, formation de l'équipe incluse.
            </span>
            <span style={{ fontSize: "13px", color: "#5A6068" }}>
              Exemple : réappro, marge et pub, comme dans la démo.
            </span>
          </div>
        </div>
        <div style={{ flex: "1 1 100%", display: "flex" }}>
          <a href="https://calendly.com/hello-autoria/30min?utm_source=autoria.dev&utm_medium=site&utm_content=offre-sur-mesure" target="_blank" rel="noopener" className="lift" style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", minHeight: "48px", background: v.accent, color: "#FFFFFF", textDecoration: "none", fontWeight: "700", padding: "12px 24px", borderRadius: "4px" }}>
            Parler de mon projet
          </a>
        </div>
      </div>
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit, minmax(min(260px, 100%), 1fr))", gap: "16px", alignItems: "stretch" }}>
        <div style={{ padding: "24px", background: "#FFFFFF", border: "1px solid #CDD1D6", borderRadius: "8px", display: "flex", flexDirection: "column", gap: "12px" }}>
          <p style={{ margin: "0", fontWeight: "800", fontSize: "20px", fontStretch: "85%" }}>
            Appel diagnostic
          </p>
          <p style={{ margin: "0", fontFamily: "'IBM Plex Mono', ui-monospace, monospace", fontSize: "28px", fontWeight: "600" }}>
            Gratuit
          </p>
          <p style={{ margin: "0", fontSize: "15px", color: "#4A5059", flexGrow: "1" }}>
            30 minutes en visio sur le fichier qui vous coûte le plus de temps : ce qui est faisable, en combien de temps, et un ordre de prix.
          </p>
          <a href="https://calendly.com/hello-autoria/30min?utm_source=autoria.dev&utm_medium=site&utm_content=offre-diagnostic" target="_blank" rel="noopener" style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", minHeight: "48px", border: "1px solid #15171A", color: "#15171A", textDecoration: "none", fontWeight: "600", borderRadius: "4px" }}>
            Réserver
          </a>
        </div>
        <div style={{ padding: "24px", background: "#FFFFFF", border: "1px solid #CDD1D6", borderRadius: "8px", display: "flex", flexDirection: "column", gap: "12px" }}>
          <p style={{ margin: "0", fontWeight: "800", fontSize: "20px", fontStretch: "85%" }}>
            Formation de votre équipe
          </p>
          <p style={{ margin: "0", fontFamily: "'IBM Plex Mono', ui-monospace, monospace", fontSize: "28px", fontWeight: "600" }}>
            {"900 € "}
            <span style={{ fontSize: "14px", fontWeight: "400", color: "#4A5059" }}>
              HT la demi-journée
            </span>
          </p>
          <ul style={{ margin: "0", padding: "0", listStyle: "none", display: "flex", flexDirection: "column", gap: "6px", fontSize: "14px", color: "#30353C", flexGrow: "1" }}>
            <li>
              — Montée en compétences sur les outils d'IA : Claude, ChatGPT
            </li>
            <li>
              — Sur vos propres chiffres : marge, stock, publicité
            </li>
            <li>
              — Des requêtes prêtes à réutiliser au quotidien
            </li>
            <li>
              — Incluse dans « Votre système »
            </li>
          </ul>
          <a href="/formation-ia-equipe-ecommerce" style={{ fontSize: "15px", fontWeight: "600" }}>
            Voir le programme
          </a>
          <a href="https://calendly.com/hello-autoria/30min?utm_source=autoria.dev&utm_medium=site&utm_content=offre-formation" target="_blank" rel="noopener" style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", minHeight: "48px", border: "1px solid #15171A", color: "#15171A", textDecoration: "none", fontWeight: "600", borderRadius: "4px" }}>
            En parler
          </a>
        </div>
        <div style={{ padding: "24px", background: "#FFFFFF", border: "1px solid #CDD1D6", borderRadius: "8px", display: "flex", flexDirection: "column", gap: "12px" }}>
          <p style={{ margin: "0", fontWeight: "800", fontSize: "20px", fontStretch: "85%" }}>
            Suivi et évolutions
          </p>
          <p style={{ margin: "0", fontFamily: "'IBM Plex Mono', ui-monospace, monospace", fontSize: "28px", fontWeight: "600" }}>
            {"300–600 € "}
            <span style={{ fontSize: "14px", fontWeight: "400", color: "#4A5059" }}>
              HT / mois
            </span>
          </p>
          <ul style={{ margin: "0", padding: "0", listStyle: "none", display: "flex", flexDirection: "column", gap: "6px", fontSize: "14px", color: "#30353C", flexGrow: "1" }}>
            <li>
              — Selon le nombre de sources branchées
            </li>
            <li>
              — Corrections et petites évolutions
            </li>
            <li>
              — Imports surveillés, adaptés quand Amazon change un rapport
            </li>
            <li>
              — Sans engagement : l'outil reste à vous
            </li>
          </ul>
          <a href="https://calendly.com/hello-autoria/30min?utm_source=autoria.dev&utm_medium=site&utm_content=offre-suivi" target="_blank" rel="noopener" style={{ display: "inline-flex", alignItems: "center", justifyContent: "center", minHeight: "48px", border: "1px solid #15171A", color: "#15171A", textDecoration: "none", fontWeight: "600", borderRadius: "4px" }}>
            En parler
          </a>
        </div>
      </div>
    </section>
  );
}
